import type { Recipient } from '../../types';
import { createContext } from 'react';

type AskATeammateContextType = {
  activeObjectId: string | null;
  setActiveObjectId: (id: string) => void;
  sendQuestion: (documentObjectId: string, message: string) => void;
  recipients: Recipient[];
};

export const AskATeammateContext = createContext<AskATeammateContextType>({
  activeObjectId: null,
  setActiveObjectId: null,
  sendQuestion: null,
  recipients: [],
});
